export default __webpack_public_path__ + "static/media/card-fire-disabled.2b15f4a6.webp";